/* global cURL */
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

export class Gallery {
  #galleryItemsContainer;
  #lightbox;

  constructor(element) {
    this.#galleryItemsContainer = element;
    if (!this.#galleryItemsContainer.classList.contains('gallery-items'))
      this.#galleryItemsContainer = this.#galleryItemsContainer.querySelector('.gallery-items');

    if (!this.#galleryItemsContainer || !this.#galleryItemsContainer.classList.contains('gallery-items')) return;

    this.#loadGalleryItems();
  }

  #loadGalleryItems = async () => {
    const galleryID = this.#galleryItemsContainer.dataset.galleryId;
    const url = new URL(`${cURL}mwork/ajax/get-gallery-items.jsp`);
    url.searchParams.append('gid', galleryID);
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Status: ${response.status}`);

      const data = await response.text();

      this.#galleryItemsContainer.innerHTML = data;
      if (typeof window.ed_loadEditbuttons === 'function') window.ed_loadEditbuttons();

      this.#initPhotoSwipe();
    }
    catch (error) {
      console.error(`Failed to get gallery items for ID ${galleryID}`, error);
      this.#galleryItemsContainer.innerHTML = `<i class="error">Fout bij het laden van het fotoalbum met ID ${galleryID}.</i>`;
    }
    finally {
      this.#galleryItemsContainer.classList.remove('loading');
    }
  };

  #initPhotoSwipe() {
    this.#lightbox = new PhotoSwipeLightbox({
      gallery: this.#galleryItemsContainer,
      children: 'a.gallery-thumbnail',
      pswpModule: PhotoSwipe,
      errorMsg: 'De afbeelding kon niet worden geladen.',
      closeTitle: 'Sluiten (Esc)',
      zoomTitle: 'Zoom in/uit',
      arrowPrevTitle: 'Vorige (pijltje links)',
      arrowNextTitle: 'Volgende (pijltje rechts)'
    });

    this.#lightbox.init();
  }
}
